import DownDeleteIcons from './DownDeleteIcons';

export default DownDeleteIcons;
